export default __webpack_public_path__ + "static/media/shella-preloader.b420bc90.svg";